export default "__VITE_ASSET__BBMdCOSc__"